import { render } from "./Icon.vue?vue&type=template&id=7b70fce3&scoped=true"
import script from "./Icon.vue?vue&type=script&lang=js"
export * from "./Icon.vue?vue&type=script&lang=js"

import "./Icon.vue?vue&type=style&index=0&id=7b70fce3&scoped=true&lang=css"

import exportComponent from "C:\\Source\\vueChatApp-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b70fce3"]])

export default __exports__